import React, { useState } from 'react'
import {Row, Col, ModalFooter} from 'react-bootstrap';
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import * as FormFields from "../../../components/formcomponents"
import { BlueButton, BlueBorderButton, CancelButton } from '../../../components/buttoncomponents'
import { useFormik } from 'formik'

export default function Informations_form(props) {
    const [isModalOpen, setIsModalOpen] = useState(props.isOpen)
    const [error, setError] = useState(false)
    const toggle = ()=>{
        setIsModalOpen(!isModalOpen)
        setTimeout(() => {
            props.toggle();
        }, 300);
    }
    const formik = useFormik(
        {
            initialValues:
            props.isEdit?
            {
                id : props.id,
                data: props.name
            }
            :
            {
                data : ''
            },
            validate :values=>{
                setError(false)
                let errors ={};
                if(!values.data){
                    errors.data = "Please enter a value!"
                }
                return errors;
            }
        }
    )
    
    const saveData = ()=>{
        if(formik.values.data != ""){
            if(Object.keys(formik.errors).length == 0){
                props.onSave(formik.values)
                toggle()
            }
        }
        else{
            setError(true)
        }
        
    }
    return (
        <Modal isOpen={isModalOpen} toggle={toggle} className='mt-10-rem property_info_modal mt-5'>
            <ModalHeader toggle={toggle}>
                <div className='font-16 font-weight-600 color-707895'>{props.title}</div>
            </ModalHeader>
            <ModalBody>
                <Row className='d-flex plr-2-rem'>
                    <FormFields.InputField
                        md={10}
                        className='mb-3'
                        name='data'
                        label={props.inputLabel}
                        val ={formik.values.data}
                        onChange = {formik.handleChange}
                        onBlur = {formik.handleBlur}
                        errors={formik.touched.data?formik.errors.data:''}
                    />
                    {error&&
                        <span className='input_error'>Please enter a value!</span>
                    }
                </Row>
            </ModalBody>
            <ModalFooter className='d-flex justify-content-start' >
                <CancelButton  value='Cancel' clickEvent={toggle}/>
                <BlueButton value={props.buttontext} clickEvent={saveData}/>
            </ModalFooter>
        </Modal>
    )
}
